import { DatabaseOwnerEntry } from "../../Api/Database";
import { useEffect, useState } from "react";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

let serverUrl = window.location.origin;

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
  }));


export default function ApiAccordion() {

    const [expanded, setExpanded] = useState(false);
    const [apikey, setApiKey] = useState("");
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});

    const handleChange = () => () => {
      setExpanded(!expanded);
    };

    // Get apikey
    useEffect(() => {
        var url = serverUrl + "/api/v1/api_key" ;
        fetch(url,{
            method:"GET",
            headers: {
              accept: 'application.json',
              'Content-Type': 'application/json',
              //'X-Recaptcha-Token': token,
            }
        })
        .then(async response => {
    
            // check for error response
            if (!response.ok ) {
                // get error message from body or default to response status
                console.log("Error in response code")
                const error = await response.text();
                return Promise.reject(error);

            }else{
    
                const data1 = await response.text();
                const data = JSON.parse(data1);
                //console.log(data);
                setApiKey(data);
            } 
        })
        .catch(error => {
            console.error("Error in API Issue: ", error);
            notifyError("Can't get API KEY: " + error);
        });
    }, []);


    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"api_settings"}
            sx={{ width: "100%" , marginTop:"20px", marginBottom:"20px"}}
            id={"api_settings"}
        >
            <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px" }}
            >
            <Typography sx={{ fontSize: "16px", fontWeight: "550" }}>
                Api details
            </Typography>
            </MuiAccordionSummary>
            <AccordionDetails>
                <div>
                    <div className="product-details">
                        <h2 className="sub-title">API KEY: </h2><p style={{wordBreak:"break-all"}}>{apikey}</p>
                        <h2></h2><p>Check out our <a href="https://test-dpp.mynext.id/docs/dpp_api/add-manufacturer" target="_blank">developer documentation</a> to learn more.</p>
                    </div>

                </div>
            </AccordionDetails>
        </Accordion>
    )
}